export const additionalMedications = [
  {
    id: 1,
    question: "Other Prescriptions",
    details:"(includes Samples)",
    isYes: null,
    add: false,
  },
  {
    id: 2,
    question: "Antibiotics",
    details:"(currently & past 3 months)",
    isYes: null,
    add: false,
  },
  {
    id: 3,
    question: "Non-Prescriptions",
    details:"(includes ASA)",
    isYes: null,
    add: false,
  },
  { id: 4, question: "Herbals or Vitamins", details:"", isYes: null, add: false },
  {
    id: 5,
    question: "Miscellaneous medications, such as inhalers, topicals, eye drops, nasal sprays, injectables, patches or cannabis products?",
    details:"", // (inhalers, topicals, eye drops, nasal sprays, injectables,patches or cannabis products)
    isYes: null,
    add: false,
  },
  {
    id: 6, question: "Medications that require routine laboratory monitoring (is medication list complete)", 
    details:"", isYes: null, add: false
  }
];

export const AdherenceTypes = {
  AsPrescribed: "asPrescribed",
  NotAsPrescribed: "notAsPrescribed",
  Stopped: "stopped",
};

export const CommonQuestionValueTypes = {
  Yes: "yes",
  No: "no",
  NotSure: "notSure",
};

/** AMR review card: medication type + therapy (stored as `type|therapy`, e.g. `Prescription|Chronic`). */
export const DEFAULT_MEDICATION_TYPE_THERAPY = "Prescription|Chronic";

export const medicationTypeTherapyOptions = [
  { value: "Prescription|Chronic", label: "Rx | Chronic / continuous" },
  { value: "Prescription|Acute", label: "Rx | Acute / short-term" },
  { value: "Non-Prescription|Chronic", label: "Non-Rx | Chronic / continuous" },
  { value: "Non-Prescription|Acute", label: "Non-Rx | Acute / short-term" },
  { value: "Natural-Product|Chronic", label: "Natural | Chronic / continuous" },
  { value: "Natural-Product|Acute", label: "Natural | Acute / short-term" },
];

const MEDICATION_TYPE_THERAPY_VALUES = new Set(
  medicationTypeTherapyOptions.map((o) => o.value)
);

/** Map legacy `medicationType`-only values from API to combined type|therapy for the review dropdown. */
export const normalizeMedicationTypeTherapy = (stored) => {
  if (stored == null || stored === "") return DEFAULT_MEDICATION_TYPE_THERAPY;
  const s = String(stored).trim();
  if (s.includes("|")) {
    return MEDICATION_TYPE_THERAPY_VALUES.has(s)
      ? s
      : DEFAULT_MEDICATION_TYPE_THERAPY;
  }
  const lower = s.toLowerCase();
  if (lower === "prescription") return "Prescription|Chronic";
  if (lower === "non-prescription") return "Non-Prescription|Chronic";
  if (lower === "natural-product" || lower === "Natural Health Product") {
    return "Natural-Product|Chronic";
  }
  return DEFAULT_MEDICATION_TYPE_THERAPY;
};

export const AmrDisplayKind = {
  CommonQuestion: "commonQuestion",
  AssessmentStatusHeading: "assessmentStatusHeading",
};

const AMR_ASSESSMENT_TITLE_BY_ADHERENCE = {
  [AdherenceTypes.NotAsPrescribed.toLowerCase()]:
    "Assessment Status - Not Taking as Prescribed",
  [AdherenceTypes.Stopped.toLowerCase()]:
    "Assessment Status - Stopped Medication",
};

const AMR_COMMON_QUESTION_LABEL = {
  [CommonQuestionValueTypes.Yes]: "Yes",
  [CommonQuestionValueTypes.No]: "No",
};

/** Human-readable adherence line for intervention documentation (print/PDF). */
export const formatAmrAdherenceStatusForDocumentation = (value) => {
  if (value == null || value === "") return "";
  const key = String(value).toLowerCase();
  if (key === String(AdherenceTypes.AsPrescribed).toLowerCase()) {
    return "Taken as Prescribed";
  }
  if (key === String(AdherenceTypes.NotAsPrescribed).toLowerCase()) {
    return "Not Taken as Prescribed";
  }
  if (key === String(AdherenceTypes.Stopped).toLowerCase()) {
    return "Stopped Medication";
  }
  return typeof value === "string" ? value : String(value);
};

export const formatAmrForDisplay = (kind, value, options = {}) => {
  if (kind === AmrDisplayKind.AssessmentStatusHeading) {
    if (value == null || value === "") return "Assessment Status";
    return (
      AMR_ASSESSMENT_TITLE_BY_ADHERENCE[String(value).toLowerCase()] ??
      "Assessment Status"
    );
  }
  if (kind === AmrDisplayKind.CommonQuestion) {
    if (value == null || value === "") return "";
    if (value === CommonQuestionValueTypes.NotSure) {
      return options.forTechnique ? "Not Applicable" : "Not Sure";
    }
    return (
      AMR_COMMON_QUESTION_LABEL[value] ??
      (typeof value === "string" ? value : String(value))
    );
  }
  return value == null || value === ""
    ? ""
    : typeof value === "string"
      ? value
      : String(value);
};

export const OverrideReasonOptions = [
  {
    value: "modify",
    label:
      "Agree with updated prescription; notify primary provider - create intervention",
  },
  {
    value: "modify-withoutNotify",
    label: "Agree with updated prescription; do not notify primary provider",
  },
  {
    value: "stopped",
    label: "Agree with stopped medication; notify primary provider - create intervention",
  },
  {
    value: "stopped-withoutNotify",
    label: "Agree with stopped medication; do not notify primary provider",
  },
  {
    value: "reassess",
    label:
      "Primary provider to reassess; create intervention",
  },
  {
    value: "free",
    label: "Other; add explanation",
  },
];

export const WhoOptions = [
  {
    value: "healthcareProvider",
    label: "Alternate Healthcare Provider",
  },
  { value: "caregiver", label: "Caregiver" },
  { value: "nursePractitioner", label: "Nurse Practitioner" },
  { value: "other", label: "Other" },
  { value: "patient", label: "Patient" },
  { value: "pharmacist", label: "Pharmacist" },
  { value: "primaryPhysician", label: "Primary Provider" },
];

export const WhenOptions = [
  { value: "Not Known", label: "Not Known" },
  { value: "Add Specific Date", label: "Add Specific Date" },
  { value: "Less than 3 months", label: "Less than 3 months" },
  { value: "3 to 6 months", label: "3 to 6 months" },
  { value: "6 months to 1 year", label: "6 months to 1 year" },
  { value: "> 1 year ago", label: "Greater than 1 year ago" },
];
//onViewAll - stopped - changed - initial
export const WhyOptions = [
  { value: "Other (Free Text)", label: "Other (Free Text)", showAlways: "always" },
  { value: "None", label: "None", showAlways: "always" },
  { value: "Reason Not Known", label: "Reason Not Known", showAlways: "always" },
  {
    value: "Adverse Reaction",
    label: "Adverse Reaction", showAlways: "onViewAll"
  },
  { value: "Allergic to Drug", label: "Allergic to Drug", showAlways: "always" },
  { value: "Breastfeeding", label: "Breastfeeding", showAlways: "onViewAll" },
  {
    value: "Changed to Alternate Medication",
    label: "Changed to Alternate Medication", showAlways: "onViewAll"
  },
  { value: "Cost is too High", label: "Cost is too High", showAlways: "onViewAll" },
  { value: "Drug Interaction", label: "Drug Interaction", showAlways: "onViewAll" },
  {
    value: "Do Not Need the Medication",
    label: "Do Not Need the Medication", showAlways: "onViewAll"
  },
  { value: "Duplicate Drug", label: "Duplicate Drug", showAlways: "onViewAll" },
  {
    value: "Fear of potential Side Effects",
    label: "Fear of potential Side Effects", showAlways: "always"
  },
  {
    value: "Medication on Back Order by Pharmacy",
    label: "Medication on Back Order by Pharmacy", showAlways: "onViewAll"
  },
  {
    value: "Medication Out of Stock by Pharmacy",
    label: "Medication Out of Stock by Pharmacy", showAlways: "onViewAll"
  },
  {
    value: "Medication Recall by Pharmacy",
    label: "Medication Recall by Pharmacy", showAlways: "onViewAll"
  },
  { value: "No Drug Coverage", label: "No Drug Coverage", showAlways: "onViewAll" },
  { value: "No Symptoms", label: "No symptoms for medical condition", showAlways: "always" },
  { value: "No Longer Taking Drug", label: "No Longer Taking Drug", showAlways: "stopped" },
  { value: "Changed the Dose", label: "Changed the Dose", showAlways: "onViewAll" },
  { value: "Pregnant", label: "Pregnant", showAlways: "onViewAll" },
  {
    value: "Side Effects / Intolerance",
    label: "Side Effects / Intolerance", showAlways: "always"
  },
  {
    value: "Taking too Many Medications",
    label: "Taking too Many Medications", showAlways: "changed"
  },
  { value: "Worry Becoming Dependent", label: "Worry Becoming Dependent", showAlways: "onViewAll" },
];

export const GeneralTimeTypes = {
  Breakfast: "Bkf",
  Lunch: "Lun",
  Dinner: "Din",
  BedTime: "Bed",
};

export const getGeneralTimeFrequency = (medCard) => {
  if (!medCard?.generalTime || medCard.generalTime.length === 0) {
    return "";
  }

  const time = [...medCard.generalTime];
  const fixedOrder = Object.values(GeneralTimeTypes);

  // Sort time array based on fixed order of codes (Bkf, Lun, etc.)
  time.sort((a, b) => fixedOrder.indexOf(a) - fixedOrder.indexOf(b));

  // Map stored codes (Bkf, Lun) to user-friendly labels (Breakfast, Lunch)
  const codeToLabel = (code) =>
    Object.entries(GeneralTimeTypes).find(([, value]) => value === code)?.[0] ||
    code;

  const displayTimes = time.map(codeToLabel);
  const count = displayTimes.length;

  switch (count) {
    case 1:
      return `once daily at ${displayTimes.join(", ")}`;
    case 2:
      return `twice daily at ${displayTimes.join(" and ")}`;
    case 3:
      return `three times a day in the ${displayTimes[0]}, ${displayTimes[1]} and ${displayTimes[2]}`;
    case 4:
      return `four times a day in the ${displayTimes[0]}, ${displayTimes[1]}, ${displayTimes[2]} and ${displayTimes[3]}`;
    default:
      return "";
  }
};